module.exports = __webpack_public_path__ + "img/17.6411b059.webp";